module.exports = __webpack_public_path__ + "media/ulcer.94020d26.wav";